import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/promptwatch.webp';
import screenshot_target from '../../../images/letterfunnel/klaasfoppen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Klaas Foppen"
      firstname="Klaas"
      companyname="Promptwatch"
      competition="Profound en Peec AI"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/klaasfoppen.js